import React from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import invoice from "../../assets/images/invoice.png";
import { Link } from "react-router-dom";

const Invoice = ({ setInvoice }) => {
  return (
    <>
      <div className={`modal-wrapper overflow-y-auto h-full}`}>
        <div className={`side-modal w-[50%] h-screen}`}>
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[80%] justify-between">
              <p className="text-[#2F80ED]">Invoice</p>
              <div onClick={() => setInvoice(false)} className="cursor-pointer">
                <img src={cross_icon} alt="cross icon"/>
              </div>
            </div>
          </div>

          <div className="flex items-center flex-col mt-10 h-screen">
            <div className="bg-[#F4F9FF] w-[80%] p-4 rounded-lg mb-10">
              <p className="text-[14px] font-bold">
                Order ID- <span className="italic font-normal">13E4347RY</span>
              </p>
            </div>

            <Link to="/dashboard" className="w-[80%]">
              <img src={invoice} alt="invoice" className="object-contain" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoice;
